import { OEM_SCAN_CONSTANTS } from "../constants/oemScanConstants";

const initialState = {
  oemScans: [],
  scansPagination: {},
  scansLoading: false,
  scansError: null,
};

const oemScanReducer = (state = initialState, action) => {
  switch (action.type) {
    case OEM_SCAN_CONSTANTS.FETCH_OEM_SCANS_REQUEST:
      return {
        ...state,
        scansLoading: true,
        scansError: null,
      };
    case OEM_SCAN_CONSTANTS.FETCH_OEM_SCANS_SUCCESS:
      return {
        ...state,
        scansLoading: false,
        oemScans: action.payload.response || [],
        scansPagination: action.payload.pagination || {},
        scansError: null,
      };
    case OEM_SCAN_CONSTANTS.FETCH_OEM_SCANS_FAILURE:
      return {
        ...state,
        scansLoading: false,
        scansError: action.payload,
        oemScans: [],
        scansPagination: {},
      };
    default:
      return state;
  }
};

export default oemScanReducer;